const pearlWhite = "#EEEDE4";
export const colors = {
  pearlWhite,
};
